
import { PropType, ref } from "vue";
import OwnerCardCareerRecord from "./OwnerCardCareerRecord.vue";
import OwnerCardTimeRecord from "./OwnerCardTimeRecord.vue";
import Team from "../shared/teams/team";
import orderBy from 'lodash/orderBy';
import Matchup from '@/shared/matchups/matchup';

function useTeamDetail(team: Team) {
  const showMatchupHistory = ref<boolean>(false);
  const selectedMatchup = ref<Matchup>();

  function loadMatchupHistory(matchup: Matchup) {
    matchup.results = orderBy(matchup.results, ['year', 'week'], ['desc', 'desc']);
    showMatchupHistory.value = true;
    selectedMatchup.value = matchup;
  }

  function rowClass(index: number) {//todo make this a useStripedRow import
    if (index % 2 === 0) {
      return "row--striped";
    } else {
      return "row--main";
    }
  }

  if (team.records) {
    team.records.matchupHistory = orderBy(team.records.matchupHistory, matchup => matchup.opponent.owner.firstName, ['asc']);
  }

  return { loadMatchupHistory, rowClass, selectedMatchup, showMatchupHistory };
}

export default {
  components: { OwnerCardCareerRecord, OwnerCardTimeRecord },
  props: {
    team: Object as PropType<Team>,
  },
  emits: {
    close: null,
  },
  setup(props: any) {
    return useTeamDetail(props.team as Team);
  },
};
